
import {
  Accordion,
  AccordionSummary,
  Box,
  Button,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { OASelectionV2, ObjetivoAprendizajeV2 } from "./types";

interface Props {
  objetivo: ObjetivoAprendizajeV2;
  selection?: OASelectionV2;

  // Abre el modal 
  onOpenModal: () => void;

  // Elimina la selección persistida en el padre
  onClearSelection?: () => void;
}

const ObjectiveCardV2 = ({
  objetivo,
  selection,
  onOpenModal,
  onClearSelection,
}: Props) => {
  const aeCount =
  selection?.aprendizajeIds?.length ??
  selection?.tree?.aprendizajesEsperados?.length ??
  0;

const ceCount =
  selection?.criterioIds?.length ??
  0;

const ogCount =
  selection?.objetivoGenericoIds?.length ??
  0;

const hasSelection = Boolean(selection);

  return (
    <Grid item xs={12} md={4}>
      <Accordion
        sx={{
          border: hasSelection ? "3px solid #FBC02D" : "2px dashed #88A9B9",
          borderRadius: "10px !important",
          overflow: "hidden",
          backgroundColor: hasSelection
            ? "rgba(248, 173, 12, 0.1)"
            : "rgba(0, 111, 149, 0.1)",
          "&::before": { display: "none" },
          "&:hover": {
            boxShadow: hasSelection
              ? "4px 8px 10px rgba(248, 173, 12, 0.5)"
              : "4px 8px 10px rgba(0, 124, 119, 0.35)",
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box>
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontWeight: "bold",
                color: "#336B87",
                fontSize: "1rem",
              }}
            >
              {objetivo.codigo}
            </Typography>

            <Typography
              sx={{
                mt: 1,
                fontFamily: "Montserrat",
                color: "#336B87",
                fontSize: "0.8rem",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 4,
                WebkitBoxOrient: "vertical",
              }}
            >
              {objetivo.objetivo}
            </Typography>

            {hasSelection && (
              <Typography
                sx={{
                  mt: 1,
                  fontFamily: "Montserrat",
                  color: "#336B87",
                  fontSize: "0.72rem",
                  opacity: 0.95,
                }}
              >
                Selección: {aeCount} AE · {ceCount} CE · {ogCount} OG
              </Typography>
            )}
          </Box>
        </AccordionSummary>

        <Box px={2} pb={2} display="flex" justifyContent="flex-end">
          {!hasSelection ? (
            <Button
              variant="contained"
              onClick={onOpenModal}
              sx={{
                borderRadius: "20px",
                backgroundColor: "#1D3D4D",
                fontFamily: "Montserrat",
                "&:hover": { backgroundColor: "#16303D" },
              }}
            >
              Seleccionar objetivo
            </Button>
          ) : (
            <Stack direction="row" spacing={1}>
              {/** SE COMENTA HASTA COMPLETAR FUNCIONALIDAD <Button
                variant="contained"
                startIcon={<EditOutlinedIcon />}
                onClick={onOpenModal}
                sx={{
                  borderRadius: "20px",
                  backgroundColor: "#1D3D4D",
                  fontFamily: "Montserrat",
                  "&:hover": { backgroundColor: "#16303D" },
                }}
              >
                Editar
              </Button>*/}

              <Button
                variant="outlined"
                startIcon={<DeleteOutlineIcon />}
                onClick={onClearSelection}
                sx={{
                  backgroundColor: "#FFFFFF",
                  color: "#FB3748",
                   borderColor: "#FB3748",
                  textTransform: "none",
                  fontFamily: "'Montserrat', sans-serif",
                  fontWeight: 600,
                  borderRadius: 2,
                  "&:hover": {
                    backgroundColor: "#FB3748",
                    color: "#FFFFFF",
                    borderColor: "#FB3748",
                  },
                }}
              >
                Eliminar
              </Button>
            </Stack>
          )}
        </Box>
      </Accordion>
    </Grid>
  );
};

export default ObjectiveCardV2;
